<template>
  <v-container fluid class="pa-0 col-12 justify-center">
    <v-app-bar flat color="red-darken-3">
      <v-app-bar-title class="hidden-sm-and-down">
        {{ $t("lekoAI.subtitle1") }}
      </v-app-bar-title>
      <v-divider class="mx-5 hidden-sm-and-down" inset vertical />
    </v-app-bar>
    <v-row class="pa-3">
      <v-col xs="8" md="7" lg="7" class="align-center">
        <v-img
          v-if="image.src"
          :src="image.src"
          alt="Uploaded Image"
          max-height="600"
          contain
          @mousemove="zoomIn"
          @mouseleave="zoomOut"
        />
        <div v-else class="default-image-text">
          {{ $t("test_img_here") }}
        </div>
      </v-col>
      <v-col xs="4" md="5" lg="5" class="mt-4">
        <h2 class="mt-4">
          {{ $t("upload_image") }}
        </h2>
        <v-form class="mt-4">
          <input
            ref="fileInput"
            type="file"
            accept="image/*"
            @change="handleFileUpload"
          />
          <v-text-field
            v-model="image.url"
            class="mt-4"
            :label="$t('enter_img_url')"
            variant="outlined"
          />
          <v-btn
            color="primary"
            class="mt-4"
            :loading="loading"
            @click="classifyImage"
          >
            {{ $t("classify_image") }}
            <v-icon end> mdi-image-search-outline </v-icon>
          </v-btn>
          <v-card v-if="predictions.length > 0" class="mt-4 pa-2">
            <h3 class="mb-2 mt-2">
              {{ $t("top_3_predictions") }}
            </h3>
            <ul>
              <li
                v-for="(prediction, index) in predictions.slice(0, 3)"
                :key="index"
              >
                <strong>{{ prediction.tagName }}</strong
                >: {{ (prediction.probability * 100).toFixed(2) }}%
              </li>
            </ul>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import zoom from "../utils/zoom";
import { dataURLtoBlob } from "../utils/files";

export default {
  data() {
    return {
      image: {
        type: null, // 'string' | 'file'
        src: null,
        url: null,
      },
      loading: false,
      predictions: [],
    };
  },
  watch: {
    "image.url": {
      handler(value) {
        if (value) {
          this.image.type = "string";
          this.image.src = value;
        }
      },
      deep: true,
    },
  },
  methods: {
    handleFileUpload() {
      this.predictions = [];
      // Get the file input element using the ref
      const { fileInput } = this.$refs;

      if (fileInput.files.length > 0) {
        const image = fileInput.files[0];
        const reader = new FileReader();
        reader.onload = (event) => {
          this.image = { type: "file", src: event.target.result, url: null };
        };
        reader.readAsDataURL(image);
      }
    },
    classifyImage() {
      this.loading = true;
      const details = {
        url:
          this.image.type === "string"
            ? "https://imagerecognitionlekotech.cognitiveservices.azure.com/customvision/v3.0/Prediction/0eabb224-dc3c-451c-ac47-da1e814bc98a/classify/iterations/Iteration5/url"
            : "https://imagerecognitionlekotech.cognitiveservices.azure.com/customvision/v3.0/Prediction/0eabb224-dc3c-451c-ac47-da1e814bc98a/classify/iterations/Iteration5/image",
        headers: {
          "Content-Type":
            this.image.type === "string"
              ? "application/json"
              : "application/octet-stream",
          "Prediction-Key": "21c696823b3f40a889e06e10105e84b0",
        },
        data:
          this.image.type === "string"
            ? { url: this.image.url }
            : dataURLtoBlob(this.image.src),
      };

      axios
        .post(details.url, details.data, { headers: details.headers })
        .then((response) => {
          this.predictions = response.data.predictions.sort(
            (a, b) => b.probability - a.probability,
          );
          this.predictions = this.predictions.slice(0, 3);
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    zoomIn(event) {
      zoom.zoomIn(2.4, event, this.rotation);
      const img = event.target;

      img.classList.add("zoomed");
    },
    zoomOut(event) {
      zoom.zoomOut(event, this.rotation);
      const img = event.target;

      img.classList.remove("zoomed");
    },
  },
};
</script>

<style scoped>
.default-image-text {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
  background-color: #ccc;
  color: #555;
  font-size: 18px;
  font-weight: bold;
}
.zoomed {
  position: relative;
  z-index: 9999;
  transform: scale(1.5);
  transition: transform 0.2s ease-in-out;
}
</style>
